module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.culturalResource) ? _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "header_margin"
  }, [_c('span', [_c('span', {
    staticClass: "site_label"
  }, [_vm._v("Smithsonian Number")]), _vm._v(" "), _c('span', {
    staticClass: "site_value"
  }, [(!_vm.isProduction) ? _c('a', {
    on: {
      "click": _vm.goProduction
    }
  }, [_vm._v(_vm._s(_vm.culturalResource.smithsonianNumber))]) : _c('span', [_vm._v(_vm._s(_vm.culturalResource.smithsonianNumber))])])]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "site_label"
  }, [_vm._v("Site Name")]), _vm._v(" "), _c('span', {
    staticClass: "site_value"
  }, [_vm._v(_vm._s(_vm.siteName))])]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "site_label"
  }, [_vm._v("Time Period")]), _vm._v(" "), _c('span', {
    staticClass: "site_value"
  }, [_vm._v(_vm._s(_vm.culturalResource.timePeriodDescription))])])]), _vm._v(" "), (_vm.currentEval) ? _c('div', [_c('div', [_c('span', {
    staticClass: "site_label"
  }, [_vm._v("Current Eligibility")]), _vm._v(" "), (!_vm.isListedLandmarkMonument) ? [_c('span', {
    staticClass: "site_value"
  }, [_vm._v(_vm._s(_vm.currentEval.eligibilityDescription || 'N/A'))]), _vm._v(" "), (_vm.currentEval.eligibilityId === 1) ? [(_vm.currentEval.isKeeperDetermined) ? _c('span', {
    staticClass: "site_value",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                        Eligible By NRHP Keeper\n                    ")]) : _vm._e()] : _vm._e()] : [(_vm.culturalResource.isListed) ? _c('span', {
    staticClass: "site_value"
  }, [_vm._v("Listed")]) : _vm._e(), _vm._v(" "), (_vm.culturalResource.isLandmark) ? _c('span', {
    staticClass: "site_value"
  }, [_vm._v("Landmark")]) : _vm._e(), _vm._v(" "), (_vm.culturalResource.isMonument) ? _c('span', {
    staticClass: "site_value"
  }, [_vm._v("Monument")]) : _vm._e()], _vm._v(" "), [_c('span', {
    staticClass: "site_label"
  }, [_vm._v("Concurred")]), _vm._v(" "), _c('span', {
    staticClass: "site_value"
  }, [_vm._v(_vm._s(_vm.currentEval.concurredDescription || "N/A"))])]], 2), _vm._v(" "), (_vm.currentEval.eligibilityId === 1 && !_vm.isListedLandmarkMonument) ? _c('div', [_c('span', {
    staticClass: "site_label"
  }, [_vm._v("Citeria")]), _vm._v(" "), _c('span', {
    staticClass: "site_value"
  }, [_vm._v(_vm._s(_vm.criteriaList.join(', ')))]), _vm._v(" "), (_vm.currentEval.isEligibleB) ? [_c('span', {
    staticClass: "site_label"
  }, [_vm._v("Associated Person")]), _vm._v(" "), _c('span', {
    staticClass: "site_value"
  }, [_vm._v(_vm._s(_vm.currentEval.associatedPerson))])] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "site_label"
  }, [_vm._v("Effect")]), _vm._v(" "), _c('span', {
    staticClass: "site_value"
  }, [_vm._v(_vm._s(_vm.currentEval.effectDescription))])], 2) : _vm._e(), _vm._v(" "), (_vm.isSegment) ? _c('div', [_c('span', {
    staticClass: "site_label"
  }, [_vm._v("Contributing Status")]), _vm._v(" "), _c('span', {
    staticClass: "site_value"
  }, [_vm._v(_vm._s(_vm.contributingStatus))])]) : _vm._e()]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0daa2ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteHeader.vue
// module id = 996
// module chunks = 1